define('score_bootstrap/Models/Search/IndexableItemBase',["jquery", "score_bootstrap/Models/SitecoreId"], function ($, SitecoreId) {
    "use strict";

    function IndexableItemBase(id, title, tiles, url) {
        Object.defineProperties(this, {
            id:    { enumerable: true, value: SitecoreId.parse(id) },
            url:   { enumerable: true, value: url },
            title: { enumerable: true, value: title },
            tiles: {
                enumerable: true,
                value: tiles.reduce(function (result, tile) {
                    result[tile.Name] = tile.Html;
                    return result;
                }, {})
            }
        });
    }

    Object.defineProperty(IndexableItemBase.prototype, "isIndexableItemBase", {
        enumerable: false,
        value: true
    });

    return IndexableItemBase;
});
